export enum PreferredLanguage {
  BahasaMalaysia = '001',
  English = '002',
  Chinese = '003',
  Tamil = '004',
  Others = '005',
}
